import { render } from "./SwipperComponent.vue?vue&type=template&id=e1697794&scoped=true"
import script from "./SwipperComponent.vue?vue&type=script&lang=js"
export * from "./SwipperComponent.vue?vue&type=script&lang=js"

import "./SwipperComponent.vue?vue&type=style&index=0&id=e1697794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1697794"]])

export default __exports__